import { useContext } from 'react'

import { NotificationContext } from '~/src/components/shared/Notification/context'

/**
 * Hook to use the Notification context
 * @returns Notification context
 */
export const useNotification = () => useContext(NotificationContext)
